import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { ENVIRONMENT, Environment } from '@environment';
import { CompetitionsService } from '@usheru-hff/movie-detail/feature-competitions';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { LocationService } from '@usheru-hff/sdk/location';
import { MovieService } from '@usheru-hff/sdk/movie';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { TemplatesService, ThemeService } from '@usheru-hff/shared/utils';
import { CookieSettingsService } from '@usheru-hff/shared/utils-cookies';
import { ImageService } from '@usheru-hff/shared/utils-image';
import { MetatagsService } from '@usheru-hff/shared/utils-metatag';
import { ShowtimeStreamingService } from '@usheru-hff/shared/utils-movie';
import { NavigationService, PageLoaderService } from '@usheru-hff/shared/utils-navigation';
import { TitleService } from '@usheru-hff/shared/utils-title';
import { TrackingService } from '@usheru-hff/sdk/tracking';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { UplayerService } from '@usheru-hff/uplayer/domain';

import { BrandedMovieTemplate } from '../branded-movie-template';

@Component({
  selector: 'ush-movie-template-c',
  templateUrl: './movie-template-c.component.html',
  styleUrls: ['./movie-template-c.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MovieTemplateCComponent extends BrandedMovieTemplate {
  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    @Inject(PLATFORM_ID) public platform,
    public override channelService: ChannelService,
    public override movieService: MovieService,
    public override themeService: ThemeService,
    public override titleService: TitleService,
    public override videPlayerService: VideoFullscreenService,
    public override metaTagService: MetatagsService,
    public override imageService: ImageService,
    public override route: ActivatedRoute,
    public override router: Router,
    public override location: Location,
    public override translationsService: TranslationsService,
    public override locationService: LocationService,
    public override navigationService: NavigationService,
    public override templatesService: TemplatesService,
    public override trackingService: TrackingService,
    public override competitionsService: CompetitionsService,
    public override pageLoader: PageLoaderService,
    public override cookiesService: CookieSettingsService,
    public override sanitizer: DomSanitizer,
    public override uplayerService: UplayerService,
    public override cd: ChangeDetectorRef,
    public override showtimeStreamingService: ShowtimeStreamingService,
    @Inject(DOCUMENT) public override document: Document
  ) {
    super(
      env,
      platform,
      channelService,
      movieService,
      themeService,
      titleService,
      videPlayerService,
      metaTagService,
      imageService,
      route,
      router,
      location,
      translationsService,
      locationService,
      navigationService,
      templatesService,
      trackingService,
      competitionsService,
      pageLoader,
      cookiesService,
      sanitizer,
      uplayerService,
      cd,
      showtimeStreamingService,
      document
    );
  }
}
